import { useEffect, useMemo } from 'react';

// The following disable directive for no-restricted-imports is intentional. We need to mport it for setup.
// eslint-disable-next-line no-restricted-imports
import GlobalScopesContainer from 'crm-legacy-global-containers/GlobalScopesContainer';
import ScopesContainer from './internal/sidebarCards/containers/ScopesContainer';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module  Remove this comment to see the full error message
import { PermissionsContext } from 'customer-data-sidebar/universal/context/PermissionsContext';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module  Remove this comment to see the full error message
import { SidebarSubjectContext } from 'customer-data-sidebar/universal/context/SidebarSubjectContext';
import getCrmObjectPrimaryDisplayLabel from './internal/sidebarCards/getCrmObjectPrimaryDisplayLabel';
import { normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import isReadOnlyObjectTypeId from 'crm-cards-sdk/utils/isReadOnlyObjectTypeId';
import { jsx as _jsx } from "react/jsx-runtime";
export default function LegacySidebarCardDataContexts({
  scopes,
  gates,
  loading,
  data,
  children
}) {
  useEffect(() => {
    const scopesObj = scopes.reduce((acc, scope) => {
      acc[scope] = true;
      return acc;
    }, {});
    ScopesContainer.set(scopesObj);
    GlobalScopesContainer.setContainer(ScopesContainer);
  }, [scopes]);
  const sidebarSubject = useMemo(() => {
    if (loading) {
      return {
        loading: true
      };
    }
    if (data) {
      return {
        definition: data.crmObject.objectTypeDefinition,
        objectType: data.crmObject.objectTypeDefinition.id,
        objectId: data.crmObject.id.toString(),
        allProperties: data.crmObject.allProperties,
        primaryDisplayLabel: getCrmObjectPrimaryDisplayLabel(data.crmObject.objectTypeDefinition.id, data.crmObject),
        primaryDisplayProperty: data.crmObject.primaryDisplayProperty
      };
    }
    return null;
  }, [data, loading]);
  const permissions = useMemo(() => {
    if (loading) {
      return {
        loading: true
      };
    }
    if (data) {
      const objectTypeId = normalizeTypeId(data.crmObject.objectTypeDefinition.id);
      return {
        canView: data.crmObject.userPermissions.currentUserCanView,
        canCreate: data.crmObject.objectTypePermissions.currentUserCanCreate,
        canEditSubject: data.crmObject.userPermissions.currentUserCanEdit,
        canDeleteSubject: data.crmObject.userPermissions.currentUserCanDelete,
        canMergeSubject: data.crmObject.userPermissions.currentUserCanMerge,
        readOnly: isReadOnlyObjectTypeId(objectTypeId),
        gates,
        scopes
      };
    }
    return null;
  }, [gates, scopes, data, loading]);
  return /*#__PURE__*/_jsx(SidebarSubjectContext.Provider, {
    value: sidebarSubject,
    children: /*#__PURE__*/_jsx(PermissionsContext.Provider, {
      value: permissions,
      children: children
    })
  });
}